import { IncidentInfoWrapper } from 'core/components/JianDetail';
import { EmergencyTeam } from 'core/components/JianDetail/EmergencyTeam';
import { PatientDetailSection } from '../PatientDetailSection';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { useNavigateWithParams } from 'core/hooks/useNavigateWithParams';
import { Select } from 'core/components/common/Select';
import { Tab } from 'core/components/common/Tab';
import { useTab } from 'core/components/common/Tab/useTab';
import { useIncidentDetailForSendai } from '../useIncidentDetailForSendai';
import { IncidentInformationView } from './IncidentInformationView';

export const IncidentDetail = () => {
  const { incidentInfo, emsTeamInfo, patients } = useIncidentDetailForSendai();

  const { patientId } = useParams();
  const [selectedPatient, setSelectedPatient] = useState(
    patients.find(p => p.id === patientId)
  );
  const selectablePatientList = patients.map(patient => ({
    value: patient.id,
    label: patient.baseInfo.name,
  }));

  const navigateWithParams = useNavigateWithParams();

  const onChangeSelectedPatient = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedPatientId = event.target.value;
    const selectedPatient = patients.find(
      patient => patient.id === selectedPatientId
    );

    if (selectedPatient) {
      setSelectedPatient(selectedPatient);
      navigateWithParams(
        `/jian-detail/${selectedPatient.incidentId}/${selectedPatientId}`
      );
    }
  };

  const { selectedTabValue, handleClickTab } = useTab({
    tabs: [...SENDAI_PATIENT_DETAIL_TABS],
    defaultTabValue: 'baseInfo',
  });

  return (
    <>
      <IncidentInfoWrapper>
        <IncidentInformationView
          incidentInfo={incidentInfo}
          patientTimeSeries={selectedPatient?.timeSeries}
        />
        <EmergencyTeam emsTeam={emsTeamInfo} />
      </IncidentInfoWrapper>
      <div className="bg-surface pt-[60px]">
        <div className="max-w-[1280px] px-[40px] m-auto flex flex-col gap-[24px]">
          <div className="ml-auto">
            <Select
              options={selectablePatientList}
              onChange={onChangeSelectedPatient}
              selected={selectedPatient?.id || ''}
            />
          </div>
          <Tab
            tabs={[...SENDAI_PATIENT_DETAIL_TABS]}
            selectedTabValue={selectedTabValue}
            onClick={handleClickTab}
          />
        </div>
      </div>
      {selectedPatient && (
        <PatientDetailSection
          patient={selectedPatient}
          selectedTab={selectedTabValue}
        />
      )}
    </>
  );
};

const SENDAI_PATIENT_DETAIL_TABS = [
  { value: 'baseInfo', label: '基本情報' },
  { value: 'cpaMode', label: 'CPAモード' },
  { value: 'requestSummary', label: '要請概要欄' },
  { value: 'findingsEmsContact', label: '接触時の所見' },
  { value: 'bystander', label: 'バイスタンダー' },
  { value: 'vitals', label: 'バイタル' },
  { value: 'collaborationActivity', label: '連携活動' },
  { value: 'treatment', label: '応急処置' },
  { value: 'relatedPersonContact', label: '関係者連絡' },
  { value: 'photo', label: '写真' },
  { value: 'video', label: '動画' },
  { value: 'activitySummary', label: '活動概要' },
  { value: 'acceptRequestHistory', label: '受入要請履歴' },
  { value: 'documents', label: '書類' },
] as const;

export type SendaiPatientDetailTabKey =
  (typeof SENDAI_PATIENT_DETAIL_TABS)[number]['value'];
